import styled from 'styled-components';
import { FormikProvider, useFormik } from 'formik';

import { media } from '../../../utils/style';

import SearchInput from '../../common/form/SearchInput';

const StyledForm = styled.form`
  display: flex;

  ${media.extraSmall`
    margin: 15px 0;
  `};

  ${media.medium`
    flex: 3;
    margin: 0;
  `};
`;

const StyledSearchInput = styled(SearchInput)`
  padding: 0;
  padding-left: 10px;
`;

const SearchForm = (props) => {
  const formikbag = useFormik({
    initialValues: {
      search: '',
    },
    onSubmit: props.onSubmit,
  });

  return (
    <FormikProvider value={formikbag}>
      <StyledForm className={props.className} onSubmit={formikbag.handleSubmit}>
        <StyledSearchInput name="search" placeholder="Buscar" />
      </StyledForm>
    </FormikProvider>
  );
};

export default SearchForm;
